import { createContext, useContext, useState } from 'react';

const ConeSearchOverlayContext = createContext();

export const useConeSearchOverlay = () => {
  const context = useContext(ConeSearchOverlayContext);
  if (!context) throw new Error('useConeSearchOverlay must be used within ConeSearchOverlayProvider');
  return context;
};

export const ConeSearchOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const openOverlay = (options = {}) => {
    setIsOpen(true);
    setIsMinimized(options.minimized || false);
  };
  const closeOverlay = () => { setIsOpen(false); setIsMinimized(false); };
  const toggleMinimized = () => setIsMinimized(prev => !prev);

  return (
    <ConeSearchOverlayContext.Provider value={{ isOpen, isMinimized, openOverlay, closeOverlay, toggleMinimized }}>
      {children}
    </ConeSearchOverlayContext.Provider>
  );
};
